module.exports = __webpack_public_path__ + "static/media/er.db81cce2.svg";